// 全てのヘッダーメニューを取得
var navList = document.querySelectorAll(".js-header-nav-link");
// カレントページのurlパスとヘッダーメニューのhrefが一致する要素にアクティブclassを付与
for (var index = 0; index < navList.length; index++) {
  var navItem = navList[index];
  if (location.pathname === navItem.getAttribute("href")) {
    navItem.classList.add("is-active");
  }
}